import { createReducer, on } from '@ngrx/store';
import { UserActions } from './user.actions';
import { UserState, initialUserState } from './models/user-state.models';

export const userReducer = createReducer(
  initialUserState,

  // Load profile
  on(UserActions.loadProfile, (state): UserState => ({
    ...state,
    loading: true,
    error: null
  })),
  on(UserActions.loadProfileSuccess, (state, { profile }): UserState => ({
    ...state,
    profile,
    loading: false,
    error: null,
    cacheTimestamp: Date.now()
  })),
  on(UserActions.loadProfileFailure, (state, { error }): UserState => ({
    ...state,
    loading: false,
    error
  })),

  // Create or sync
  on(UserActions.createOrSync, (state): UserState => ({
    ...state,
    loading: true,
    error: null
  })),
  on(UserActions.createOrSyncSuccess, (state, { profile }): UserState => ({
    ...state,
    profile,
    loading: false,
    error: null,
    cacheTimestamp: Date.now()
  })),
  on(UserActions.createOrSyncFailure, (state, { error }): UserState => ({
    ...state,
    loading: false,
    error
  })),

  // Update profile
  on(UserActions.updateProfile, (state): UserState => ({
    ...state,
    loading: true,
    error: null
  })),
  on(UserActions.updateProfileSuccess, (state, { profile }): UserState => ({
    ...state,
    profile,
    loading: false,
    error: null,
    cacheTimestamp: Date.now()
  })),
  on(UserActions.updateProfileFailure, (state, { error }): UserState => ({
    ...state,
    loading: false,
    error
  })),

  // Delete personal data
  on(UserActions.deletePersonalData, (state): UserState => ({
    ...state,
    deletingPersonalData: true,
    error: null
  })),
  on(UserActions.deletePersonalDataSuccess, (state): UserState => ({
    ...state,
    deletingPersonalData: false,
    error: null
  })),
  on(UserActions.deletePersonalDataFailure, (state, { error }): UserState => ({
    ...state,
    deletingPersonalData: false,
    error
  })),

  // Delete account
  on(UserActions.deleteAccount, (state): UserState => ({
    ...state,
    deletingAccount: true,
    error: null
  })),
  on(UserActions.deleteAccountSuccess, (state): UserState => ({
    ...initialUserState
  })),
  on(UserActions.deleteAccountFailure, (state, { error }): UserState => ({
    ...state,
    deletingAccount: false,
    error
  })),

  // Set profile (direct)
  on(UserActions.setProfile, (state, { profile }): UserState => ({
    ...state,
    profile,
    error: null,
    cacheTimestamp: Date.now()
  })),

  // Clear profile
  on(UserActions.clearProfile, (): UserState => ({
    ...initialUserState
  })),

  // Invalidate cache
  on(UserActions.invalidateCache, (state): UserState => ({
    ...state,
    cacheTimestamp: null
  }))
);
